import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import AppErrorBoundary from './components/AppErrorBoundary';
import RuntimeConfigurationFailure from './components/RuntimeConfigurationFailure';
import SiteAccessGate from './components/SiteAccessGate';
import reportWebVitals from './reportWebVitals';
import { initPerformanceMonitoring } from './utils/performanceBudgets';
import { initClientObservability } from './utils/clientObservability';
import { installChunkLoadRecovery } from './utils/chunkLoadRecovery';
import { warnRuntimeModeOnce } from './utils/runtimeMode';

initClientObservability();
installChunkLoadRecovery();
// Development only: say which Firebase lane is active instead of failing silently.
warnRuntimeModeOnce();

const root = ReactDOM.createRoot(document.getElementById('root'));
import('./App')
  .then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <AppErrorBoundary>
          <SiteAccessGate>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </SiteAccessGate>
        </AppErrorBoundary>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    root.render(<RuntimeConfigurationFailure error={error} />);
  });

initPerformanceMonitoring(reportWebVitals);
